<template>
  <div>
    <div class="row">
       <div class="col-md-10">
           
       </div>
       <div class="col-md-2">

       </div>
    </div>
    <div class="col-md-12">
        <h4>Cadastro de Unidade Organizacional</h4>
    </div>
    
    <div class="col-md-12" v-if="msgAlterada" >
        <div
            class="card"
            style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 6px !important;"
            v-if="msg==1"
        >
           <div class="card-body">
              <div class="row">
                <div class="col-md-12">{{msgAlterada}}</div>
              </div>
            </div>
        </div>
        <div
            class="card"
            style="background-color: rgb(170 72 50) !important;color: #fff !important;margin-bottom: 6px !important;"
            v-if="msg==0"
        >
           <div class="card-body">
              <div class="row">
                <div class="col-md-12">{{msgAlterada}}</div>
              </div>
            </div>
        </div>
        <div
            class="card"
            style="background-color: rgb(191 187 54) !important;color: #fff !important;margin-bottom: 6px !important;"
            v-if="msg==2"
        >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">{{msgAlterada}}</div>
              </div>
            </div>
        </div>
    </div>

    <div class="col-md-12" >
       <div class="row">
          <div class="col-md-12" style="margin-top:20px;margin-bottom:20px;">
            <label>Unidade Organizacional</label>
            <input
              type="text"
              placeholder="Nome Unidade Organizacional"
              maxlength="250"
              v-model="departamento.nome"
              class="form-control"
              :style="styleNome"
            />
            <label
              class="control-label"
              v-if="styleNome!=''"
              style="color:rgb(243 0 0);font-size: 12px;"
            >*Obrigatorio</label>
          </div>
        </div>
       <!-- <div class="row">
           <div class="col-md-5">
              <div class="checkbox">
                <label>Exibir ao publico</label>
                <switch-button v-model="departamento.publico" color="#253DB9" meuid="nada" modulo="departamento" funcao="cadastrar"></switch-button>
              </div>
           </div>
        </div> -->
        <div class="row">
           <div class="col-md-5">
              <div class="checkbox">
                <label>Status</label>
                <switch-button v-model="departamento.status" color="#253DB9" meuid="nada" modulo="departamento" funcao="cadastrar"></switch-button>
              </div>
           </div>
        </div>
        <div class="row">
            <div class="text-center" style="margin-left:15px;margin-top:20px;margin-bottom:20px;">
                <button type="button" class="btn btn-primary btn-fill float-left" @click.prevent="cadastrar">  
                  Cadastrar
                </button>
                <button class="btn btn-danger" @click="retornar()"  style="margin-left: 8px;">Cancelar</button>
            </div>
        </div> 
    </div>  
    
  </div>
  
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import axios from 'axios';
import store from "src/store.js"
import 'src/controller/sistema/assuntoSecretariaController.js'
import SwitchButton from 'src/components/switch.vue'

export default {
  name: 'departamento',
  components: {
    VueGoodTable,
    SwitchButton
  },
  data(){
    return {
      departamento:{
        nome:null,
        publico:true,
        status:true,
      },
      msgAlterada: null,
      msg: null,
      publico:null,
      status:null,
      styleNome: "",
    };
  },
  methods: {
      async cadastrar(){
        try {

          if(this.departamento.nome==null || this.departamento.nome==""){
            this.msgAlterada= "O campo de nome do departamento não pode ser vazio!";
            this.styleNome = "border: 2px solid rgb(243 0 0);";
            this.msg = 0;
            return false   
          }

          if(this.departamento.publico == true){
             this.publico=1;
          }else{
             this.publico=0;
          }

          if(this.departamento.status == true){
             this.status = 1;
          }else{
             this.status = 0;
          }
          
          if (this.publico == 1 && this.status == 0) {
            this.msgAlterada= "Para exibir ao Publico o Campo Status deve está Ativado!";
            this.msg = 0;
            return false 
          }

          let data = await this.$secretariaCadastrar(this.departamento.nome,this.publico,this.status);
          //alert('Cadastrado com Sucesso!');
          this.msgAlterada= "Cadastrado com Sucesso!";
          this.msg = 1;
          //this.$router.push({name: 'departamentos'} ); 
          setTimeout( () => this.$router.push({ path: '/sistema/departamentos'}), 150);       
        }catch (e) {
              
        }
      },
      retornar(){
        this.$router.push({name: 'departamentos'} );
      }

  },
  beforeMount() {
    try {
      
    }catch(e){
      
    }    
    
  }
};
</script>



